import axios from "axios";
import { getAuthHeader, catchApi } from "../../utils";
import { cachedGet } from "../../utils/apiResponseCache";

const base = () => (window.RUNTIME_CONFIG?.API_BASE_URL ?? "");

export const EXPLORE_CATALOG_CACHE_KEY = "explore:catalog";
const EXPLORE_CATALOG_TTL_MS = 5 * 60_000;

export const v2_fetch_explore_catalog = () =>
  cachedGet(
    EXPLORE_CATALOG_CACHE_KEY,
    () =>
      catchApi(
        axios.get(`${base()}/v2/explore/catalog`, getAuthHeader()).then((r) => r.data)
      ),
    EXPLORE_CATALOG_TTL_MS
  );

export const v2_fetch_explore_requests = () =>
  axios.get(`${base()}/v2/explore/module-requests`, getAuthHeader()).then((r) => r.data);

export const v2_request_explore_module = (payload) =>
  axios.post(`${base()}/v2/explore/module-request`, payload, getAuthHeader()).then((r) => r.data);

export const v2_revoke_explore_module = (payload) =>
  axios.post(`${base()}/v2/explore/module-revoke`, payload, getAuthHeader()).then((r) => r.data);
